.background {
    display: flex;
    background: var(--mantine-color-dark-6);
    width: 100%;
    height: 100%;
}

.container {
    display: grid;
    grid-template-columns: auto 400px;
    grid-gap: 1.75rem;
    width: 100%;
    height: 100%;
    padding: 2rem 1.5rem;
    max-width: 1600px;
    margin: 0 auto;
}

.expertUniversityColumn {
    display: flex;
    flex-direction: column;
    width: 100%;
    overflow: hidden;
}
